export default __webpack_public_path__ + "static/media/GraphCalenderIcon.60a606f3.svg";